import React, { useEffect, useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import axios from "./components/AxiosInstance.jsx";

import GameScreen from "./components/GameScreen.jsx";
import GameWin from "./components/GameWin.jsx";
import GameOver from "./components/GameOver.jsx";
import Accueil from "./components/Accueil.jsx";
import StatMobile from "./components/StatistiquesMobile.jsx";
import Header from "./components/Header.jsx";
import EcoEnergyStats from "./components/EcoEnergyStatsMobile.jsx";
import Login from "./components/Login.jsx";
import PrivateRoute from "./components/PrivateRoute.jsx";
import Layout from "./components/Layout.jsx";
import "./components/styles/boutons.css";
import LandingPage from "./LandingPage.jsx";
import AdminPage from "./components/AdminPage.jsx";
import ConferencePage from "./components/conference/ConferencePage.jsx";
import ConferenceRoute from "./components/conference/ConferenceRoute.jsx";
import { PrompterRoute } from './components/conference/prompteur';
import HistoryVerdict from "./components/HistoryVerdict.jsx";
import AdminRoute from "./components/AdminRoute.jsx";
import MultiLobbyHub from "./components/multi/MultiLobbyHub.jsx";
import GameLobby from "./components/multi/GameLobby.jsx";
import MultiGameScreen from "./components/multi/MultiGameScreen.jsx";
import SalleQuestions from "./components/salle/SalleQuestions.jsx";

const AppContent = () => {
  const [gameState, setGameState] = useState({
    joueur: {},
    impacts: [],
    relations: [],
    countries_dict: {},
    year: 0
  });

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    refreshGameState();
  }, []);

  const stat = () => navigate("/stats/countries");

  const refreshGameState = useCallback(async () => {

    const token = localStorage.getItem("jwtToken");
    if (!token) return;

    // Don't redirect when on multi routes
    const multiRoutes = ['/multi', '/lobby/', '/multi/game/'];
    const isMultiRoute = multiRoutes.some(r => location.pathname.startsWith(r));
    if (isMultiRoute) return;
    // Page publique des questions de la salle : jamais de redirection vers le jeu.
    if (location.pathname === '/q') return;

    try {
      const response = await axios.get("/game_state");
      const newState = response.data.game_state;
      setGameState(newState);
      if (newState.state === "init" && location.pathname !== "/accueil") {
        navigate("/accueil");
      } else if (newState.state === "game" && location.pathname !== "/game") {
        navigate("/game");
      } else if (newState.state === "win" && location.pathname !== "/win" && location.pathname !== "/review") {
        navigate("/win");
      } else if (newState.state === "lose" && location.pathname !== "/over" && location.pathname !== "/review") {
        navigate("/over");
      }
    } catch (error) {
      console.error("Erreur récupération état du jeu", error)
    };
  }, [navigate, location.pathname]);

  return (
    <Routes>

      <Route path="/login" element={
        <Layout>
          <Login refreshGameState={refreshGameState} gameState={gameState} />
        </Layout>
      } />
      <Route path="/LandingPage" element={<Navigate to="/" replace />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/conference" element={
        <AdminRoute>
          <ConferencePage />
        </AdminRoute>
      } />
      <Route path="/conference/:conferenceId" element={
        <AdminRoute>
          <ConferenceRoute />
        </AdminRoute>
      } />
      {/* Prompteur : second onglet, synchronisé avec le diaporama.
          Déclaré APRÈS `/conference/:conferenceId` mais plus spécifique, donc
          react-router v7 le fait gagner — l'ordre n'a pas d'importance ici. */}
      <Route path="/conference/:conferenceId/prompteur" element={
        <AdminRoute>
          <PrompterRoute />
        </AdminRoute>
      } />

      {/* Questions de la salle — page publique du QR code des conférences */}
      <Route path="/q" element={<SalleQuestions />} />

      {/* Landing page par défaut */}
      <Route path="/" element={<LandingPage />} />

      {/* Routes protégées */}
      <Route path="/game" element={
        <PrivateRoute>
          <Layout>
            <GameScreen initialGameState={gameState} refreshGameState={refreshGameState} stat={stat} />
          </Layout>
        </PrivateRoute>
      } />
      <Route path="/accueil" element={
        <PrivateRoute>
          <Layout>
            <Accueil gameState={gameState} setGameState={setGameState} refreshGameState={refreshGameState} loading={loading} />
          </Layout>
        </PrivateRoute>
      } />
      <Route path="/win" element={
        <PrivateRoute>
          <Layout>
            <Header gameState={gameState} refreshGameState={refreshGameState} />
            <GameWin gameState={gameState} />
          </Layout>
        </PrivateRoute>
      } />
      <Route path="/over" element={
        <PrivateRoute>
          <Layout>
            <Header gameState={gameState} refreshGameState={refreshGameState} />
            <GameOver gameState={gameState} />
          </Layout>
        </PrivateRoute>
      } />
      < Route path="/review" element={
        < PrivateRoute >
          <Layout>
            <GameScreen initialGameState={gameState} refreshGameState={refreshGameState} stat={stat} />
          </Layout>
        </PrivateRoute >
      } />
      < Route path="/verdict" element={
        < PrivateRoute >
          <Layout>
            <HistoryVerdict gameState={gameState} refreshGameState={refreshGameState} />
          </Layout>
        </PrivateRoute >
      } />


      {/* Routes multijoueur */}
      <Route path="/multi" element={
        <PrivateRoute>
          <MultiLobbyHub />
        </PrivateRoute>
      } />
      <Route path="/lobby/:gameId" element={
        <PrivateRoute>
          <GameLobby />
        </PrivateRoute>
      } />
      <Route path="/multi/game/:gameId" element={
        <PrivateRoute>
          <Layout>
            <MultiGameScreen refreshGameState={refreshGameState} stat={stat} />
          </Layout>
        </PrivateRoute>
      } />

      < Route path="/stats/countries" element={
        < PrivateRoute >
          <Layout>
            <Header gameState={gameState} refreshGameState={refreshGameState} />
            <StatMobile gameState={gameState} mobile="PC" />
          </Layout>
        </PrivateRoute >
      } />
      < Route path="/stats/ecoEnergy" element={
        < PrivateRoute >
          <Layout>
            <Header gameState={gameState} refreshGameState={refreshGameState} />
            <EcoEnergyStats gameState={gameState} mobile="PC" />
          </Layout>
        </PrivateRoute >
      } />
    </Routes >
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
